module.exports = {
  loadingPng: require(`./loading.png`),
  loadingWebp: require(`./loading.webp`)
};
